import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import * as go from "gojs";
@Injectable()
export class GoItemFactoryService {
    //send single click to consumer
    //number here is some sort of requirement of gojs or rxjs
    //this gets converted to the go event eventually
    public _diagramChange = new BehaviorSubject<number>(0);
    diagramChange$ = this._diagramChange.asObservable();

  constructor() { 
      this.nodeTemplateMap = this.buildNodeTemplateMap();
  }
  public readonly lightText:string = "whitesmoke";  
  public nodeTemplateMap: go.Map<string, go.Part>;
  public startKey: number = 1;
    public endKey: number = 999;
    buildDiagram(element: string | HTMLElement): go.Diagram {
      //TODO: determine types
      var result: go.Diagram = go.GraphObject.make(go.Diagram, element,  // must name or refer to the DIV HTML element
    {
        initialContentAlignment: go.Spot.TopCenter,
        allowDrop: true,  // must be true to accept drops from the Palette
        "LinkDrawn": this.showLinkLabel,  // this DiagramEvent listener is defined below
        "LinkRelinked": this.showLinkLabel,
        /*scrollsPageOnFocus: false,*/
        "undoManager.isEnabled": true,
        nodeTemplateMap: this.nodeTemplateMap
          }); 
    result.linkTemplate = this.buildLinkTemplate();
    result.toolManager.linkingTool.temporaryLink.routing = go.Link.Orthogonal;
    result.toolManager.relinkingTool.temporaryLink.routing = go.Link.Orthogonal;
    result.linkTemplateMap.add("link", this.buildLinkTemplate()); 
    result.linkTemplateMap.add("unselectable", this.buildUnselectableLink());
      result.linkTemplateMap.add("redo", this.buildRedoLink());
      result.linkTemplateMap.add("review", this.buildReviewLink());

    return result;
  }  

    buildPalette(element: string | HTMLElement): go.Palette {
    return            go.GraphObject.make(go.Palette, element,  // must name or refer to the DIV HTML element
    {
      //TODO: Figure out how to get a reference to the nodeTemplateMap
        /*scrollsPageOnFocus: false,*/
        nodeTemplateMap: this.nodeTemplateMap,  // share the templates used by myDiagram
        model: new go.GraphLinksModel([  // specify the contents of the Palette
            { category: "inputForm", text: "Add Input Form" }/*,
            { category: "decision", text: "Add Decision" },
            { category: "transition", text: "Add Transition" }*/
        ])
    });
  }
  public showLinkLabel(e: any){
      //TODO: Determine real types
      var label = e.subject.findObject("LABEL");
      if (label !== null) label.visible = (e.subject.fromNode.data.figure === "Diamond");
  }
  public buildUnselectableLink(): go.Link {
      return go.GraphObject.make(go.Link,  // the whole link panel
          {
              routing: go.Link.Normal,
              curve: go.Link.JumpOver,
              corner: 5, toShortLength: 4,
              relinkableFrom: true,
              relinkableTo: true,
              reshapable: true,
              resegmentable: true,
              selectable: false,
          },
          new go.Binding("points").makeTwoWay(),
          go.GraphObject.make(go.Shape,  // the highlight shape, normally transparent
              { isPanelMain: true, strokeWidth: 8, stroke: "transparent", name: "HIGHLIGHT" }),
          go.GraphObject.make(go.Shape,  // the link path shape
              { isPanelMain: true, stroke: "rgba(0,0,0,0.2)", strokeWidth: 2 }),
          go.GraphObject.make(go.Shape,  // the arrowhead
              { toArrow: "standard", stroke: null, fill: "rgba(0,0,0,0.2)" })
      );
  }
  public buildLinkTemplate(): go.Link {
    return go.GraphObject.make(go.Link,  // the whole link panel
        {
            routing: go.Link.Orthogonal,
            curve: go.Link.None,
          corner: 5, toShortLength: 4,
          relinkableFrom: true,
          relinkableTo: true,
          reshapable: true,
          resegmentable: true,
          fromSpot: go.Spot.BottomSide,
          toSpot: go.Spot.TopSide,
          
          // mouse-overs subtly highlight links:
          mouseEnter: (e: Event, link: any) => { link.findObject("HIGHLIGHT").stroke = "rgba(30,144,255,0.2)"; },
          mouseLeave: (e: Event, link: any) => { link.findObject("HIGHLIGHT").stroke = "transparent"; }
      },
      new go.Binding("points").makeTwoWay(),
      go.GraphObject.make(go.Shape,  // the highlight shape, normally transparent
          { isPanelMain: true, strokeWidth: 8, stroke: "transparent", name: "HIGHLIGHT" }),
      go.GraphObject.make(go.Shape,  // the link path shape
          { isPanelMain: true, stroke: "gray", strokeWidth: 2 }),
      go.GraphObject.make(go.Shape,  // the arrowhead
          { toArrow: "standard", stroke: null, fill: "gray" }),
      go.GraphObject.make(go.Panel, "Auto",  // the link label, normally not visible
          {
              visible: true,
              name: "LABEL"
          },
          new go.Binding("visible", "visible").makeTwoWay(),
          go.GraphObject.make(go.Shape, "Rectangle",  // the label shape
              {
                  fill: "#dddddd",
                  stroke: "#dddddd",
              }),
          go.GraphObject.make(go.TextBlock, "Add Name",  // the label
              {
                  textAlign: "center",
                  font: "8pt helvetica, arial, sans-serif",
                  stroke: "#333333",
                  editable: false,
                  margin:2
              },
              new go.Binding("text"))
      )
  );
  }

    public buildReviewLink(): go.Link {
        return go.GraphObject.make(go.Link,
            {
                routing: go.Link.Orthogonal, 
                curve: go.Link.JumpGap,
                corner: 5,
                toShortLength: 4,
                relinkableFrom: true,
                relinkableTo: true,
                reshapable: true,
                resegmentable: true,
                toSpot: go.Spot.BottomSide,
                // mouse-overs subtly highlight links:
                mouseEnter: (e: Event, link: any) => { link.findObject("HIGHLIGHT").stroke = "rgba(30,144,255,0.2)"; },
                mouseLeave: (e: Event, link: any) => { link.findObject("HIGHLIGHT").stroke = "transparent"; }
            },
            new go.Binding("points").makeTwoWay(),
            go.GraphObject.make(go.Shape,  // the highlight shape, normally transparent
                { isPanelMain: true, strokeWidth: 8, stroke: "transparent", name: "HIGHLIGHT" }),
            go.GraphObject.make(go.Shape,  // the link path shape
                { isPanelMain: true, stroke: "#666fff", strokeWidth: 2 },
                new go.Binding("stroke", "color"),
                new go.Binding("strokeWidth", "width"),
                new go.Binding("strokeDashArray", "dash")),

            go.GraphObject.make(go.Shape,  // the arrowhead
                { toArrow: "standard", stroke: null, fill: "#666fff" }),
            go.GraphObject.make(go.Panel, "Auto",  // the link label, normally not visible
                {
                    visible: true,
                    name: "LABEL"
                },
                new go.Binding("visible", "visible").makeTwoWay(),
                go.GraphObject.make(go.Shape, "Rectangle",  // the label shape
                    {
                        fill: "#dddddd",
                        stroke: "#dddddd",
                    }),
                go.GraphObject.make(go.TextBlock, "Add Name",  // the label
                    {
                        textAlign: "center",
                        font: "8pt helvetica, arial, sans-serif",
                        stroke: "#333333",
                        editable: false,
                        margin: 2
                    },
                    new go.Binding("text"))
            )
        );
    }
  public buildRedoLink(): go.Link {
      return go.GraphObject.make(go.Link,  // the whole link panel
          {
              routing: go.Link.AvoidsNodes,
              curve: go.Link.None,
              corner: 5, toShortLength: 4, 
              relinkableFrom: true,
              relinkableTo: true,
              reshapable: true,
              resegmentable: true,
              // mouse-overs subtly highlight links:
              mouseEnter: (e: Event, link: any) => { link.findObject("HIGHLIGHT").stroke = "rgba(30,144,255,0.2)"; },
              mouseLeave: (e: Event, link: any) => { link.findObject("HIGHLIGHT").stroke = "transparent"; },
              fromSpot: go.Spot.BottomCenter,
              toSpot: go.Spot.TopCenter
          },
          
          new go.Binding("points").makeTwoWay(),
          go.GraphObject.make(go.Shape,  // the highlight shape, normally transparent
              { isPanelMain: true, strokeWidth: 8, stroke: "transparent", name: "HIGHLIGHT" }),
          go.GraphObject.make(go.Shape,  // the link path shape
              { isPanelMain: true, stroke: "#a44f60", strokeWidth: 2 },
              new go.Binding("stroke", "color"),
              new go.Binding("strokeWidth", "width"),
              new go.Binding("strokeDashArray", "dash")), 
               
          go.GraphObject.make(go.Shape,  // the arrowhead
              { toArrow: "standard", stroke: null, fill: "#a44f60" }),
          go.GraphObject.make(go.Panel, "Auto",  // the link label, normally not visible
              {
                  visible: true,
                  name: "LABEL"
              },
              new go.Binding("visible", "visible").makeTwoWay(),
              go.GraphObject.make(go.Shape, "Rectangle",  // the label shape
                  {
                      fill: "#dddddd",
                      stroke:null
                  }),
              go.GraphObject.make(go.TextBlock, "Add Name",  // the label
                  {
                      textAlign: "center",
                      font: "8pt helvetica, arial, sans-serif",
                      stroke: "#843c4a",
                      editable: false,
                      margin: 2,
                      
                  },
                  new go.Binding("text"))
          )
      );
  }
  public buildEnd(): go.Node {
      return go.GraphObject.make(go.Node, "Spot", this.nodeStyle(false),
          { deletable: true, selectable: true },
    go.GraphObject.make(go.Panel, "Vertical",
        go.GraphObject.make(go.Shape, "Circle",
            { maxSize: new go.Size(40, 40), fill: "#DC3C00", stroke: null }),
        go.GraphObject.make(go.TextBlock, "End",
            { font: "bold 9pt Helvetica, Arial, sans-serif", stroke: "#093241" },
            new go.Binding("text"))
    ),
    // three named ports, one on each side except the bottom, all input only:
    this.makePort("T", go.Spot.Top, false, true),
    this.makePort("L", go.Spot.Left, false, true),
    this.makePort("R", go.Spot.Right, false, true),
    this.makePort("B", go.Spot.Bottom, false, true)
    );
  }
  public buildStart(): go.Node {
      return go.GraphObject.make(go.Node, "Spot", this.nodeStyle(false),
          {deletable:false, selectable: true},
        go.GraphObject.make(go.Panel, "Vertical",
        go.GraphObject.make(go.Shape, "Circle",
            { maxSize: new go.Size(40, 40), fill: "#709721", stroke: null }),
        go.GraphObject.make(go.TextBlock, "Start",
            {font: "bold 9pt Helvetica, Arial, sans-serif", stroke: "#093241"},
            new go.Binding("text"))
    ),
    // three named ports, one on each side except the bottom, all input only:
        this.makePort("T", go.Spot.Top, false, false),
        this.makePort("L", go.Spot.Left, false, false),
        this.makePort("R", go.Spot.Right, false, false),
        this.makePort("B", go.Spot.Bottom, false, false)
    );
  }
  public buildDecision(): go.Node {
      return go.GraphObject.make(go.Node, "Spot", this.nodeStyle(false),
          { deletable: false, selectable: true, movable: true },
    // the main object is a Panel that surrounds a TextBlock with a rectangular Shape 
        go.GraphObject.make(go.Panel, "Vertical", 
        go.GraphObject.make(go.Shape,
            {
                figure: "Diamond",
                fill: "#fff",
                stroke: "rgba(0,0,0,0.2)",
                height: 30,
                width: 30
                
            })/*,
        go.GraphObject.make(go.TextBlock,
            {
                font: "bold 9pt Helvetica, Arial, sans-serif",
                stroke: "#4a4a4a",
                wrap: go.TextBlock.WrapFit,
                editable: false,
                margin: 5
            },
            new go.Binding("text").makeTwoWay())*/
    ),
    // four named ports, one on each side:
    this.makePort("T", go.Spot.Top, true, true),
    this.makePort("L", go.Spot.Left, true, true),
    this.makePort("R", go.Spot.Right, true, true),
    this.makePort("B", go.Spot.Bottom, true, true)
    );
  }
  public buildTransition(): go.Node {
    return go.GraphObject.make(go.Node, "Spot", this.nodeStyle(true),
    // the main object is a Panel that surrounds a TextBlock with a rectangular Shape
    go.GraphObject.make(go.Panel, "Vertical",
        go.GraphObject.make(go.Shape,
            {
                figure: "cloud",
                fill: "#efefef",
                stroke: "#4a4a4a",
                maxSize: new go.Size(40,40)
            }),
        go.GraphObject.make(go.TextBlock,
            {
                font: "bold 9pt Helvetica, Arial, sans-serif",
                stroke: "#4a4a4a",
                wrap: go.TextBlock.WrapFit,
                editable: false,
                margin: 5
            },
            new go.Binding("text").makeTwoWay())
    ),
    // four named ports, one on each side:
    this.makePort("T", go.Spot.Top, true, true),
    this.makePort("L", go.Spot.Left, true, true),
    this.makePort("R", go.Spot.Right, true, true),
    this.makePort("B", go.Spot.Bottom, true, true)
    );
  }
  public buildButton(): go.Node {
    return go.GraphObject.make(go.Node, "Spot", this.nodeStyle(false),
    // the main object is a Panel that surrounds a TextBlock with a rectangular Shape
    go.GraphObject.make(go.Panel, "Auto",
        go.GraphObject.make(go.Shape,
            {
                figure: "RoundedRectangle",
                fill: "#dddddd",
                stroke: "#4a4a4a",
            }),
        go.GraphObject.make(go.TextBlock,
            {
                font: "bold 9pt Helvetica, Arial, sans-serif",
                stroke: "#4a4a4a",
                wrap: go.TextBlock.WrapFit,
                editable: false,
                margin: 5
            },
            new go.Binding("text").makeTwoWay())
    ),
    // four named ports, one on each side:
    this.makePort("T", go.Spot.Top, false, true),
    this.makePort("L", go.Spot.Left, true, true),
    this.makePort("R", go.Spot.Right, true, true),
    this.makePort("B", go.Spot.Bottom, true, false)
    );
  }

  public makePort(name:string, spot: go.Spot, output:boolean, input:boolean) : go.Shape{
    return go.GraphObject.make(go.Shape, "Circle",{
      fill:"transparent", stroke:null,
      desiredSize : new go.Size(8,8),
      alignment: spot, alignmentFocus: spot,  // align the port on the main Shape
      portId: name,  // declare this object to be a "port"
      fromSpot: spot, toSpot: spot,  // declare where links may connect at this port
      fromLinkable: output, toLinkable: input,  // declare whether the user may draw links to/from here
      cursor: "pointer" // show a different cursor to indicate potential link point
    })
  }

  public nodeStyle(showPorts: boolean): any{
      if (showPorts) {
          return [
              // The Node.location comes from the "loc" property of the node data,
              // converted by the Point.parse static method.
              // If the Node.location is changed, it updates the "loc" property of the node data,
              // converting back using the Point.stringify static method.
              new go.Binding("location", "loc", go.Point.parse).makeTwoWay(go.Point.stringify),
              {
                  // the Node.location is at the center of each node
                  locationSpot: go.Spot.Center,
                  //isShadowed: true,
                  //shadowColor: "#888",
                  // handle mouse enter/leave events to show/hide the ports
                  mouseEnter: (e: Event, obj: any) => { this.showPorts(obj.part, true); },
                  mouseLeave: (e: Event, obj: any) => { this.showPorts(obj.part, false); }
              }
          ];
      } else {
          return [
              new go.Binding("location", "loc", go.Point.parse).makeTwoWay(go.Point.stringify),
              {
                  // the Node.location is at the center of each node
                  locationSpot: go.Spot.Center,
              }
          ];
      }

  }


  public showPorts(node, show): void {
    node.ports.each(function (port) {
        port.stroke = (show ? "white" : null);
    });
}

  public buildInputForm(): go.Node {
    return go.GraphObject.make(go.Node, "Spot", this.nodeStyle(false),
    // the main object is a Panel that surrounds a TextBlock with a rectangular Shape
        go.GraphObject.make(go.Panel, "Vertical",
            {
                name: "container",
                padding: 5
            },
        go.GraphObject.make(go.Shape, "File",
            {
                fill: "#369ad0",
                stroke: "#1f4458",
                height: 30,
                width: 30,
                
            },
              new go.Binding("figure", "figure")),
          go.GraphObject.make(go.TextBlock,
              {
                  stroke: "#133243",
                  font: "bold 9pt Helvetica, Arial, sans-serif",
                  wrap: go.TextBlock.WrapFit,
                  editable: false,
              },
              new go.Binding("text").makeTwoWay())
      ),
      // four named ports, one on each side:
    this.makePort("T", go.Spot.Top, false, false),
    this.makePort("L", go.Spot.Left, false, false),
    this.makePort("R", go.Spot.Right, false, false),
    this.makePort("B", go.Spot.Bottom, false, false)
    );
  }
  public buildReviewForm(): go.Node {
      return go.GraphObject.make(go.Node, "Spot", this.nodeStyle(false),
          // the main object is a Panel that surrounds a TextBlock with a rectangular Shape
          go.GraphObject.make(go.Panel, "Vertical",
              {
                  name: "container",
                  padding: 5
              },
              go.GraphObject.make(go.Shape, "BpmnEventConditional",
                  {
                      fill: "#f1b24e",
                      stroke: "#9f6810",
                      height: 30,
                      width: 30,

                  },
                  new go.Binding("figure", "figure")),
              go.GraphObject.make(go.TextBlock,
                  {
                      stroke: "#093241",
                      font: "bold 9pt Helvetica, Arial, sans-serif",
                      wrap: go.TextBlock.WrapFit,
                      editable: false,
                  },
                  new go.Binding("text").makeTwoWay())
          ),
          // four named ports, one on each side:
          this.makePort("T", go.Spot.Top, false, false),
          this.makePort("L", go.Spot.Left, false, false),
          this.makePort("R", go.Spot.Right, false, false),
          this.makePort("B", go.Spot.Bottom, false, false)
      );
  }
  
  public buildNodeTemplateMap(): go.Map<string,go.Part> {
    let nodeTemplateMap = new go.Map<string,go.Part>();

    //nodeTemplateMap.add("startForm", this.buildStartForm());
    nodeTemplateMap.add("inputForm", this.buildInputForm());
    nodeTemplateMap.add("reviewForm", this.buildReviewForm());
    //nodeTemplateMap.add("button",this.buildButton());
    nodeTemplateMap.add("transition",this.buildTransition());
    nodeTemplateMap.add("decision", this.buildDecision());
    nodeTemplateMap.add("start", this.buildStart());
    nodeTemplateMap.add("end", this.buildEnd());
    return nodeTemplateMap;
  }
  
}
